module.exports = __webpack_public_path__ + "static/PermanentlyDisabled-881c7cf9ddc6df2cca2cc491e6de0274.png";